module.exports = __webpack_public_path__ + "static/media/client4.c7e7f319.svg";